import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { hasAccess } from "../auth/permissions";

const RequireAuth = ({ access }) => {

  const { auth } = useAuth();
  const location = useLocation();
  const isAllowed = hasAccess(auth?.profile_id, access);
  const isAuthenticated = Boolean(auth?.accessToken);

  return (

    isAuthenticated && isAllowed
      ? <Outlet /> 
      : isAuthenticated
        ? <Navigate to="/unauthorized" state={{ from: location }} replace />
        : <Navigate to="/login" state={{ from: location }} replace />

  )

}


export default RequireAuth;
